import React from 'react';
import useFetch from 'use-http';

const useFetchFromPath = ({
  user = null,
  route = null,
  disabled = false,
}) => {
  const {
    get,
    error,
    loading,
  } = useFetch();
  const [results, setResults] = React.useState(null);

  const refresh = () => {
    if (route) get(route).then(setResults);
  };

  React.useEffect(() => {
    if (!user || !route || disabled) return undefined;
    let cancelled = false;
    (async () => {
      const targets = await get(route);
      if (cancelled) return;
      setResults(targets);
    })();
    return () => { cancelled = true; };
  }, [user, route, disabled]);

  return {
    results,
    error,
    refresh,
    loading,
  };
};

export default useFetchFromPath;
